import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson1DefaultStartCode = `%lang starknet

// Implicit arguments are passed down to any subsequent function calls that would require them.
// Make good usage of this feature to pass this lesson!

func parent_function{a : felt, b : felt}() -> (result : felt) {
    alloc_locals;
    let (local intermediate_result_1) = child_function_1();
    let (local intermediate_result_2) = child_function_2();
    return (result=intermediate_result_1 + intermediate_result_2);
}
${doNotModifyCodeAbove}`;

export const lesson1DefaultEndCode = `${doNotModifyCodeBelow}
@external
func test_sum{syscall_ptr : felt*}() {
    let a = 3;
    let b = 5;
    with a, b {
        let (result) = parent_function();
        assert result = 14;
    }

    return ();
}`;

export const lesson1DefaultMiddleCode = `// TODO: fix the "child_function_1" and "child_function_2" signatures to make the test pass

func child_function_1() -> (result : felt) {
    // Do not change the function body
    return (result=2*a);
}

func child_function_2() -> (result : felt) {
    // Do not change the function body
    return (result=b+3);
}`;
